import { render, staticRenderFns } from "./SaldosPage.vue?vue&type=template&id=290a1c44&scoped=true"
import script from "./SaldosPage.vue?vue&type=script&lang=ts"
export * from "./SaldosPage.vue?vue&type=script&lang=ts"
import style0 from "./SaldosPage.vue?vue&type=style&index=0&id=290a1c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a1c44",
  null
  
)

export default component.exports